// Public URL of the privacy policy (GDPR). Replace with the hosted page.
export const PRIVACY_POLICY_URL =
  import.meta.env.VITE_PRIVACY_POLICY_URL ?? "https://dermovo.pl/polityka-page";
